import { GridUtils } from '@atlassian/amkt-common';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import YellowButton from '../../../../../../../common/YellowButton';

import styles from './EmailHit.less';

export default class EmailHit extends Component {
  static propTypes = {
    onButtonClick: PropTypes.func.isRequired,
    screenClass: PropTypes.string.isRequired,
  };

  render() {
    const largeScreenClass = GridUtils.foldScreenClass(this.props.screenClass)(
      false,
      true,
      true,
      true,
      true
    );
    const emailHitContainer = classNames({
      [styles.emailHit]: true,
      [styles.largeEmailHit]: largeScreenClass,
      [styles.smallEmailHit]: !largeScreenClass,
    });

    return (
      <div className={emailHitContainer}>
        <div className={styles.text}>The latest app updates delivered to your inbox.</div>
        <div className={styles.buttonWrapper}>
          <YellowButton
            className={styles.button}
            onClick={this.props.onButtonClick}
            text="Subscribe"
          />
        </div>
      </div>
    );
  }
}
